/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { SKIP_INTERCEPT_HEADER } from '@ideapa/app-error';
import { NotificaDto, NotificaListWithCounter } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class NotificaApiClient extends BaseCRUDApiClient<NotificaDto> {
  baseUrl = this.config.apiEndpoint + '/notifica';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  getUserLatestNotifications() {
    return this.http.get<NotificaListWithCounter>(
      `${this.baseUrl}/user/latest`,
      { headers: new HttpHeaders({ [SKIP_INTERCEPT_HEADER]: '1' }) }
    );
  }
}
